import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Button, Card, CardActionArea, CardHeader, Divider, TextField, Typography, Fab, Dialog, DialogContent, DialogTitle, IconButton, Box, Stack, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ReceiptIcon from '@mui/icons-material/Receipt';
import CloseIcon from '@mui/icons-material/Close';
import ThermalInvoiceServices from './ThermalInvoiceServices';
import { NumericFormat } from 'react-number-format';

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <NumericFormat {...other} getInputRef={ref}
      onValueChange={(values) => { onChange({ target: { name: props.name, value: values.value, }, }); }}
      thousandSeparator isNumericString prefix="RD$"
    />
  );
});

// --- COMPONENTES DE VISTA MOVIDOS FUERA ---

const DesktopView = ({
  formValues,
  selectedServices,
  previousStepHandler,
  handleReservationSubmit,
  employee,
  paymentMethod,
  handlePaymentMethod,
  cashPaid,
  handlePaidChange,
  subTotal,
  ITBIS,
  ITBISValue,
  pendingToPay,
  total,
  inputRef,
  bank,
  handleBankChange,
  reference,
  handleReferenceChange,
  banksOptions = [],
  isPaymentDisabled // Prop para deshabilitar el botón
}) => {
  return (
    <div className='checkout-main-container' style={{ display: 'flex', flexDirection: 'row', height: 'calc(100vh - 74px)', width: '100%' }}>
      <div className='left-side-container payment-inf' style={{ backgroundColor: 'aliceblue', alignItems: 'center', width: '30%', height: 'calc(100vh - 74px)', display: 'flex', flexDirection: 'column' }}>
        <div className='methodOf-paid-container' style={{ width: '90%', marginTop: 10 }}>
          <h2 style={{ marginBottom: '50px', color: 'rgb(247, 89, 171)', fontSize: '30px' }}>Método de pago:</h2>
          <CardActionArea style={{ marginBottom: 10 }} onClick={() => handlePaymentMethod('efectivo')}>
            <Card sx={paymentMethod === 'efectivo' ? { color: 'green', border: 'green solid 2px' } : { color: '#531dab' }}>
              <CardHeader title='Efectivo'></CardHeader>
            </Card>
          </CardActionArea>
          <CardActionArea style={{ marginBottom: 10 }} onClick={() => handlePaymentMethod('transferencia')}>
            <Card sx={paymentMethod === 'transferencia' ? { color: 'green', border: 'green solid 2px' } : { color: '#531dab' }}>
              <CardHeader title='Transferencia' ></CardHeader>
            </Card>
          </CardActionArea>
        </div>

        {paymentMethod === 'transferencia' && (
          <div style={{ width: '90%', marginTop: 10, padding: '0 1rem' }}>
            <h3 style={{ marginBottom: '20px', color: 'rgb(247, 89, 171)', textAlign: 'center' }}>Detalles de Transferencia:</h3>
            <Stack spacing={2}>
              <FormControl fullWidth>
                <InputLabel id="bank-select-label-desktop">Banco</InputLabel>
                <Select
                  labelId="bank-select-label-desktop"
                  id="bank-select-desktop"
                  value={bank}
                  label="Banco"
                  onChange={(e) => handleBankChange(e.target.value)}
                >
                  {banksOptions.map((b) => (
                    <MenuItem key={b.id} value={b.id}>
                      {b.bank}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                label="Referencia"
                value={reference}
                onChange={handleReferenceChange} // Pasar la función directamente
                fullWidth
                variant="outlined"
                autoComplete="off"
              />
            </Stack>
          </div>
        )}

        <Divider flexItem sx={{ marginTop: 5 }} />
        <div className='cash-paid-container' style={{ width: '80%', height: '30%', display: 'flex', alignItems: 'center' }}>
          <TextField
            label="Total pagado"
            value={paymentMethod === 'efectivo' ? Math.ceil(cashPaid) : Number(subTotal * ITBISValue).toFixed(2)}
            onChange={handlePaidChange}
            name='cashPaid'
            InputProps={{ inputComponent: NumericFormatCustom }}
            variant='outlined'
            fullWidth
            margin='normal'
            inputRef={inputRef}
            autoComplete='off'
            autoFocus={true}
          />
        </div>
        <Divider flexItem />
        <div className='control-btn-container' style={{ width: '95%', height: '20%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Button variant='contained' onClick={previousStepHandler} sx={{ backgroundColor: '#f759ab', color: '#fff', '&:hover': { backgroundColor: '#eb2f96' }, padding: '10px 20px', fontSize: '16px', borderRadius: '8px' }}>
            <ArrowBackIosNewIcon /> Regresar
          </Button>
          <Button
            variant='contained'
            sx={{ backgroundColor: '#f759ab', color: '#fff', '&:hover': { backgroundColor: '#eb2f96' }, padding: '10px 20px', fontSize: '16px', borderRadius: '8px' }}
            disabled={isPaymentDisabled()} // Lógica mejorada
            onClick={handleReservationSubmit}
          >
            Procesar pago
          </Button>
        </div>
      </div>
      <Divider flexItem orientation='vertical' />
      <div className="right-side-container paid-inf" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row', height: '100%', width: '70%' }}>
        <div style={{ width: '65%', display: 'flex', justifyContent: 'center' }}>
          <Card sx={{ width: '70%', padding: 3, borderRadius: 3, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', background: 'linear-gradient(145deg, #ffffff, #f3f3f3)' }}>
            <div className="total-to-paid-container" style={{ width: '100%', marginBottom: '10px', textAlign: 'center', padding: '10px 0', borderBottom: '1px solid #d9d9d9' }}>
              <Typography variant="h4" sx={{ color: '#2c3e50', fontWeight: 600 }}>
                Total a pagar: RD$ {(Number(subTotal) * ITBISValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </Typography>
            </div>
            <Box sx={{ padding: 2 }}>
              <Typography variant="h6" sx={{ color: '#2c3e50', fontWeight: 400, mb: 1 }}>
                {paymentMethod.toUpperCase()}: RD$ {(paymentMethod === 'efectivo' ? cashPaid : subTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </Typography>
              <Typography variant="h6" sx={{ color: '#2c3e50', fontWeight: 400, mb: 1 }}>
                DEVUELTO: RD$ {paymentMethod === 'efectivo' && ((cashPaid - (Number(subTotal) * ITBISValue)) > 0 ? (cashPaid - (Number(subTotal) * ITBISValue)) : 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </Typography>
              <Divider sx={{ my: 1 }} />
              <Typography variant="h6" sx={{ color: '#2c3e50', fontWeight: 400, mb: 1 }}>
                Total facturado: RD$ {(pendingToPay + Number(subTotal)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </Typography>
              <Typography variant="h6" sx={{ color: '#2c3e50', fontWeight: 400, mb: 1 }}>
                Total pendiente: RD$ {(pendingToPay).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </Typography>
            </Box>
          </Card>
        </div>
        <div className='invoice-main-container' style={{ height: 'calc(100vh - 74px)', overflowY: 'auto', width: '35%' }}>
          <ThermalInvoiceServices
            employee={employee}
            subTotal={subTotal}
            ITBIS={ITBIS}
            ITBISValue={ITBISValue}
            paymentMethod={paymentMethod}
            formValues={formValues}
            selectedServices={selectedServices}
            cashPaid={cashPaid}
            total={total}
            pendingToPay={pendingToPay}
          />
        </div>
      </div>
    </div>
  );
};

const MobileView = ({
  formValues,
  selectedServices,
  previousStepHandler,
  handleReservationSubmit,
  employee,
  paymentMethod,
  handlePaymentMethod,
  cashPaid,
  handlePaidChange,
  subTotal,
  ITBIS,
  ITBISValue,
  pendingToPay,
  total,
  inputRef,
  bank,
  handleBankChange,
  reference,
  handleReferenceChange,
  banksOptions = [],
  isPaymentDisabled // Prop para deshabilitar el botón
}) => {
  const [openInvoice, setOpenInvoice] = useState(false);

  const handleOpenInvoice = () => setOpenInvoice(true);
  const handleCloseInvoice = () => setOpenInvoice(false);

  return (
    <div style={{ padding: '1rem', display: 'flex', flexDirection: 'column', height: '100%', boxSizing: 'border-box' }}>
      <Card sx={{ padding: 2, marginBottom: 2 }}>
        <Typography variant="h5" sx={{ color: '#2c3e50', fontWeight: 600, textAlign: 'center', marginBottom: 2 }}>
          Total a pagar: RD$ {(Number(subTotal) * ITBISValue).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </Typography>
      </Card>

      <div className='methodOf-paid-container' style={{ width: '100%', marginBottom: '1rem' }}>
        <h3 style={{ color: 'rgb(247, 89, 171)' }}>Método de pago:</h3>
        <CardActionArea style={{ marginBottom: 10 }} onClick={() => handlePaymentMethod('efectivo')}>
          <Card sx={paymentMethod === 'efectivo' ? { color: 'green', border: 'green solid 2px' } : {}}>
            <CardHeader title='Efectivo' />
          </Card>
        </CardActionArea>
        <CardActionArea onClick={() => handlePaymentMethod('transferencia')}>
          <Card sx={paymentMethod === 'transferencia' ? { color: 'green', border: 'green solid 2px' } : {}}>
            <CardHeader title='Transferencia' />
          </Card>
        </CardActionArea>
      </div>

      {paymentMethod === 'transferencia' && (
        <Stack spacing={2} sx={{ my: 2 }}>
          <FormControl fullWidth>
            <InputLabel id="bank-select-label-mobile">Banco</InputLabel>
            <Select
              labelId="bank-select-label-mobile"
              id="bank-select-mobile"
              value={bank}
              label="Banco"
              onChange={(e) => handleBankChange(e.target.value)}
            >
              {banksOptions.map((b) => (
                <MenuItem key={b.id} value={b.id}>
                  {b.bank}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Referencia"
            value={reference}
            onChange={handleReferenceChange} // Pasar la función directamente
            fullWidth
            variant="outlined"
            autoComplete="off"
          />
        </Stack>
      )}

      <TextField
        label="Total pagado"
        value={paymentMethod === 'efectivo' ? Math.ceil(cashPaid) : Number(subTotal * ITBISValue).toFixed(2)}
        onChange={handlePaidChange}
        name='cashPaid'
        InputProps={{ inputComponent: NumericFormatCustom }}
        variant='outlined'
        fullWidth
        margin='normal'
        inputRef={inputRef}
        autoComplete='off'
        autoFocus={true}
      />

      <div className='control-btn-container' style={{ marginTop: 'auto', display: 'flex', justifyContent: 'space-between', paddingTop: '1rem' }}>
        <Button variant='contained' onClick={previousStepHandler} sx={{ backgroundColor: '#f759ab', color: '#fff' }}>
          <ArrowBackIosNewIcon /> Regresar
        </Button>
        <Button
          variant='contained'
          sx={{ backgroundColor: '#f759ab', color: '#fff' }}
          disabled={isPaymentDisabled()} // Lógica mejorada
          onClick={handleReservationSubmit}
        >
          Procesar pago
        </Button>
      </div>

      <Fab color="primary" sx={{ position: 'fixed', bottom: 100, right: 16, backgroundColor: '#f759ab' }} onClick={handleOpenInvoice}>
        <ReceiptIcon />
      </Fab>

      <Dialog open={openInvoice} onClose={handleCloseInvoice} fullWidth sx={{ maxWidth: '100%' }}>
        <DialogTitle>
          Detalle de Factura
          <IconButton onClick={handleCloseInvoice} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <ThermalInvoiceServices
            employee={employee}
            subTotal={subTotal}
            ITBIS={ITBIS}
            ITBISValue={ITBISValue}
            paymentMethod={paymentMethod}
            formValues={formValues}
            selectedServices={selectedServices}
            cashPaid={cashPaid}
            total={total}
            pendingToPay={pendingToPay}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

// --- COMPONENTE PRINCIPAL CheckOutServices ---

function CheckOutServices({
  formValues,
  selectedServices,
  previousStepHandler,
  handlePostRequest,
  employee,
  handlePaymentMethodChange,
  banksOptions,
  handleBankChange,
  handleReferenceChange
}) {
  const [paymentMethod, setPaymentMethod] = useState('efectivo');
  const [cashPaid, setCashPaid] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [ITBIS, setITBIS] = useState(false);
  const [ITBISValue, setITBISValue] = useState(1);
  const [pendingToPay, setPendingToPay] = useState(0);
  const [bank, setBank] = useState('');
  const [reference, setReference] = useState('');

  const inputRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handlePaymentMethod = (method) => {
    setPaymentMethod(method);
    handlePaymentMethodChange(method);
    // Si se cambia a efectivo, el monto pagado debe ser el del input
    if (method === 'transferencia') {
        setCashPaid(subTotal);
    }
  };

  const handlePaidChange = (value) => {
    const paid = Number(value.target.value);
    setCashPaid(paid);
  };

  const onBankChange = (bankId) => {
    setBank(bankId);
    handleBankChange(bankId);
  }

  // --- FUNCIÓN CORREGIDA ---
  const onReferenceChange = (event) => {
    const value = event.target.value; // Ahora recibe el evento correctamente
    setReference(value);
    handleReferenceChange(value);
  }

  const calculateSubTotal = useCallback(() => {
    const sumTotal = (services) => services.reduce((acc, service) => {
      const price = (service.amountPaid && service.amountPaid > 0) ? service.amountPaid : (typeof service.amountPaid === 'string' ? parseFloat(service.amountPaid.replace(/,/g, '')) : 0);
      return acc + price;
    }, 0);
    const newSubTotal = sumTotal(selectedServices);
    setSubTotal(newSubTotal);
    // Si el método de pago actual es transferencia, actualiza cashPaid
    if (paymentMethod === 'transferencia') {
        setCashPaid(newSubTotal);
    }
  }, [selectedServices, paymentMethod]);

  const calculateTotalOfServices = useCallback((services) => {
    return services.reduce((acc, service) => {
      const price = service.priceWDisc && service.priceWDisc > 0 ? service.priceWDisc : (typeof service.servicePrice === 'string' ? parseFloat(service.servicePrice.replace(/,/g, '')) : service.servicePrice);
      return acc + (price * service.quantity);
    }, 0);
  }, []);

  const calcPendingToPay = useCallback(() => {
    const totalToPaid = calculateTotalOfServices(selectedServices);
    setPendingToPay(totalToPaid - subTotal);
  }, [selectedServices, subTotal, calculateTotalOfServices]);

  const calcTotal = useCallback(() => {
    const totalServices = calculateTotalOfServices(selectedServices);
    const comboPrice = (formValues.reservation?.comboPrice && parseFloat(formValues.reservation.comboPrice.replace(/,/g, ''))) || 0;
    setTotal(totalServices + comboPrice);
  }, [selectedServices, formValues, calculateTotalOfServices]);

  const handleReservationSubmit = useCallback(async () => {
    handlePostRequest();
  }, [handlePostRequest]);

  // --- LÓGICA MEJORADA PARA DESHABILITAR EL BOTÓN ---
  const isPaymentDisabled = () => {
    if (paymentMethod === 'efectivo') {
      const requiredAmount = ITBIS ? Number(subTotal) * ITBISValue : Number(subTotal);
      return Number(cashPaid) < requiredAmount;
    }
    if (paymentMethod === 'transferencia') {
      return !bank || !reference.trim();
    }
    return true;
  };

  useEffect(() => {
    if (paymentMethod === 'efectivo' && inputRef.current) {
      inputRef.current.focus();
    }
  }, [paymentMethod]);

  useEffect(() => {
    calculateSubTotal();
  }, [calculateSubTotal]);

  useEffect(() => {
    calcPendingToPay();
    calcTotal();
  }, [subTotal, calcPendingToPay, calcTotal]);

  const viewProps = {
    formValues,
    selectedServices,
    previousStepHandler,
    handleReservationSubmit,
    employee,
    paymentMethod,
    handlePaymentMethod,
    cashPaid,
    handlePaidChange,
    subTotal,
    ITBIS,
    ITBISValue,
    pendingToPay,
    total,
    inputRef,
    banksOptions,
    bank,
    handleBankChange: onBankChange,
    reference,
    handleReferenceChange: onReferenceChange,
    isPaymentDisabled
  };

  return isMobile ? <MobileView {...viewProps} /> : <DesktopView {...viewProps} />;
}

export default CheckOutServices;